import DashboardContent from "@app/components/DashboardContent";

export default function Dashboard() {
  return <DashboardContent />;
}
